export const GET_PURCHASE_COIN_HISTORY = "GET_PURCHASE_COIN_HISTORY";

//Get Offline recharge history
export const GET_OFFLINE_RECHARGE_HISTORY = "GET_OFFLINE_RECHARGE_HISTORY";
